<div class="login-failed">
  <h1>Sign-in failed</h1>
  <p>We could not sign you in. If your account has been deactivated, please contact NHC.</p>
  <button type="button" class="btn btn-primary" (click)="signOut()">Sign out and try again</button>
</div>
